import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    label: {
      font: theme.custom.font.heading3,
      marginRight: '8px',
      color: theme.custom.colors.primary
    },
    containerErr: {
      '& label': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& span': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '&>div:nth-child(2)': {
        border: `2px dashed ${theme.custom.colors.error1} !important`,
      },
    },
    disable: {
      '& *': {
        cursor: 'not-allowed !important',
      },
      '& span': {
        opacity: 0.5,
      },
    },
    viewLabel: {
      display: 'flex',
      alignItems: 'center',
    },
    viewImage: {
      marginTop: '20px',
      position: 'relative',
      display: 'inline-block',
    },
    imgUploaded: {
      maxWidth: '240px',
      maxHeight: '240px',
      objectFit: 'contain',
    },
    uploadImage: {
      marginTop: '20px',
      width: '300px',
      height: '240px',
      border: '2px dashed #D2D2D2',
      borderRadius: '10px',
      backgroundColor: '#FDFDFD',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
      '& input[type="file"]': {
        fontSize: 0,
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        cursor: 'pointer',
        width: '100%',
      },
    },
    uploadImageLabel: {
      font: theme.custom.font.heading6,
    },
    tooltip: {
      // all: 'unset',
      color: 'unset',
      backgroundColor: 'unset',
      maxWidth: 'unset',
      maxHeight: 'unset',
    },
    buttonRemove: {
      background: theme.custom.colors.white,
      color: theme.custom.colors.midBlack,
      textAlign: 'center',
      fontWeight: 400,
      cursor: 'pointer',
      position: 'absolute',
      width: '24px',
      height: '24px',
      borderRadius: '24px',
      boxShadow: '1px 1px 6px rgba(0, 0, 0, 0.15)',
      fontSize: '16px',
      top: -15,
      right: -15,
      '&:hover': {
        background: '#F0F0F0',
      },
    },
  };
});

export default useStyles;
